import './bookStructure.css'

const BookStructure = () => {
  return (
    <section className="bookStructure">
      <div className="bookStructure__container section__padding">

        <h2 className="bookStructure__title">
          Estructura del libro
        </h2>

        <div className="bookStructure__content">
          <p>
            <strong>Parte 1 · Fundamentos de la educación menstrual</strong><br />
            Orígenes del término, definición del campo, marco ético y político.
          </p>

          <p>
            <strong>Parte 2 · La figura de la educadora menstrual</strong><br />
            Rol, competencias, formación, metodología y código ético.
          </p>

          <p>
            <strong>Parte 3 · Glosario crítico</strong><br />
            Más de 100 conceptos clave sobre cultura, activismo y derechos menstruales.
          </p>

          <p>
            <strong>Parte 4 · Recursos para actuar y profundizar</strong><br />
            Manifiesto por los derechos menstruales, referentes, bibliografía completa y rigurosa.
          </p>
        </div>

        <div className="bookStructure__cta">
          <a
            href="https://traficantes.net/libros/educaci%C3%B3n-menstrual"
            target="_blank"  // abre en nueva pestaña
            rel="noopener noreferrer"
            className="bookStructure__button"
          >
            Lo quiero
          </a>
        </div>

      </div>
    </section>
  )
}

export default BookStructure
